import * as React from 'react';

import config from '../../../commonData';
import { Container, Nav, Navbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Pencil, PencilSquare, PlusCircleDotted, X } from 'react-bootstrap-icons';

// import IconButton from '@mui/material/IconButton';
// import Tooltip from '@mui/material/Tooltip';
// import { IconEdit, IconFileX, IconPrinter, IconUserPlus, IconX } from '@tabler/icons';

export default function AccessibilityTooltips({ selected, handleClickOpen, setLoading, setLoad, load, setOpenSnak, setMsg, setSeverity }) {
    const toArray = (selected) => Object.keys(selected).map((id) => id * 1);
    const id = JSON.stringify(toArray(selected)).replace('[', '').replace(']', '');

    async function handleClickDeleteLigne(id) {
        const log = config.search(config.userdroit, 'SAD');
        const log1 = config.search(config.userdroit, 'TSP');
        if (log == undefined) {
            if (log1 == undefined) {
                setMsg("Vous n'avez pas le droit d'effectuer cette action, merci de contacter l'administrateur");
                setSeverity('danger');
                setOpenSnak(true);
                return;
            }
        }
        let text = 'Voulez-vous supprimer cette ligne';
        let res = window.confirm(text);
        if (res === false) {
            return;
        }
        setLoading(true);
        const response = await fetch(config.ipapi + '/api/del-typedep/' + id, {
            method: 'DELETE'
        });
        const json = await response.json();
        if (json.status) {
            setOpenSnak(true);
            setMsg(json.msg);
            setSeverity('success');
            setLoad(!load);
        } else {
            setOpenSnak(true);
            setMsg(json.msg);
            setSeverity('error');
        }
        setLoading(false);
    }

    return (
        <Navbar expand="lg" bg="light" variant="light">
            <Container>
                <Nav className="me-auto">
                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="tooltip-disabled">Ajouter un nouveau type (catégorie) de dépenses</Tooltip>}
                    >
                        <Nav.Link href="#/admin/typedepense" onClick={() => handleClickOpen(1, 0)}>
                            <PlusCircleDotted color="orange" size={20} /> Créer
                        </Nav.Link>
                    </OverlayTrigger>
                    {id != 0 ? (
                        <>
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id="tooltip-disabled">Modifier la ligne sélectionné</Tooltip>}
                            >
                                <Nav.Link href="#/admin/typedepense" onClick={() => handleClickOpen(1, id)}>
                                    <PencilSquare color="blue" size={20} /> Modifier
                                </Nav.Link>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="bottom"
                                overlay={<Tooltip id="tooltip-disabled">Supprimer la ligne sélectionnée</Tooltip>}
                            >
                                <Nav.Link href="#/admin/typedepense" onClick={() => handleClickDeleteLigne(id)}>
                                    <X color="red" size={20} /> Supprimer
                                </Nav.Link>
                            </OverlayTrigger>
                        </>
                    ) : (
                        <></>
                    )}
                </Nav>
            </Container>
        </Navbar>
    );
}
